// Fires on every page view, including SPA route changes
exports.onRouteUpdate = function () {
  var img = new Image(1, 1)
  img.src = 'https://p.xad.com?id=288148&sid=9086572&ts=' + Date.now()
}
